import { useStoreState, useStoreActions } from 'easy-peasy';
import { Message, toaster } from 'rsuite';
import { useEffect } from 'react';

/**
 * Global toast notification component
 * Displays toast messages from the store
 */
const ToastNotification = () => {
	const toast = useStoreState((state) => state.toast);
	const hideToast = useStoreActions((actions) => actions.hideToast);

	useEffect(() => {
		if (toast.visible) {
			const message = (
				<Message showIcon type={toast.type} closable>
					{toast.message}
				</Message>
			);

			toaster.push(message, {
				placement: 'topEnd',
				duration: 5000,
				onClose: hideToast
			});

			// Clear the toast from state
			hideToast();
		}
	}, [toast.visible, toast.message, toast.type, hideToast]);

	return null;
};

export default ToastNotification;
